import { Machine, sendParent, send, assign } from "xstate";

const validPhoneRegex = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const companyName = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isCompanyNameEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const streetAddress = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isStreetAddressEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const streetAddress2 = {
  initial: "noError",
  states: {
    noError: {}
  }
};

const state = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isStateEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};
const city = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isCityEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};
const postalCode = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isPostalCodeEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

const companyPhoneNumber = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isCompanyPhoneEmpty",
            target: "error.empty"
          },
          {
            cond: "isCompanyPhoneFormatBad",
            target: "error.badFormat"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {},
        badFormat: {}
      }
    }
  }
};

const title = {
  initial: "noError",
  states: {
    noError: {
      on: {
        SUBMIT: [
          {
            cond: "isTitleEmpty",
            target: "error.empty"
          }
        ]
      }
    },
    error: {
      initial: "empty",
      states: {
        empty: {}
      }
    }
  }
};

export const getStep2 = (values: any) => {
  const defaultValues = {
    companyName: "",
    streetAddress: "",
    streetAddress2: "",
    city: "",
    state: "",
    postalCode: undefined,
    companyPhoneNumber: undefined,
    title: ""
  };

  const config = {
    id: "step2",
    initial: "ready",
    context: {
      ...defaultValues,
      ...values
    },
    states: {
      ready: {
        type: "parallel",
        on: {
          INPUT_COMPANY_NAME: {
            actions: "setCompanyName",
            target: "ready.companyName.noError"
          },
          INPUT_STREET_ADDRESS: {
            actions: "setStreetAddress",
            target: "ready.streetAddress.noError"
          },
          INPUT_STREET_ADDRESS2: {
            actions: "setStreetAddress2",
            target: "ready.streetAddress.noError"
          },
          INPUT_CITY: {
            actions: "setCity",
            target: "ready.city.noError"
          },
          INPUT_STATE: {
            actions: "setState",
            target: "ready.state.noError"
          },
          INPUT_POSTAL_CODE: {
            actions: "setPostalCode",
            target: "ready.postalCode.noError"
          },
          INPUT_COMPANY_PHONE: {
            actions: "setCompanyPhoneNumber",
            target: "ready.companyPhoneNumber.noError"
          },
          INPUT_TITLE: {
            actions: "setTitle",
            target: "ready.title.noError"
          },
          SUBMIT: {
            cond: (_0, _1, meta) => {
              if (
                meta.state.matches("ready.companyName.error") ||
                meta.state.matches("ready.streetAddress.error") ||
                meta.state.matches("ready.city.error") ||
                meta.state.matches("ready.state.error") ||
                meta.state.matches("ready.postalCode.error") ||
                meta.state.matches("ready.companyPhoneNumber.error") ||
                meta.state.matches("ready.title.error")
              ) {
                return false;
              }

              return true;
            },

            target: "finished"
          }
        },
        states: {
          companyName: {
            ...companyName
          },
          streetAddress: {
            ...streetAddress
          },
          streetAddress2: {
            ...streetAddress2
          },
          city: {
            ...city
          },
          state: {
            ...state
          },
          postalCode: {
            ...postalCode
          },
          companyPhoneNumber: {
            ...companyPhoneNumber
          },
          title: {
            ...title
          }
        }
      },
      noError: {},
      finished: {
        type: "final"
      },
      error: {
        type: "parallel",
        companyName: { ...companyName },
        streetAddress: { ...streetAddress },
        streetAddress2: { ...streetAddress2 },
        city: { ...city },
        state: { ...state },
        postalCode: { ...postalCode },
        companyPhoneNumber: { ...companyPhoneNumber },
        title: { ...title }
      },
      submitted: { onEntry: "complete" }
    }
  };

  function isEmpty(someString: string) {
    if (!someString || someString.length === 0) {
      return true;
    }

    return false;
  }

  const step2 = Machine(config as any, {
    actions: {
      setCompanyName: assign((context: any, event: any) => ({
        companyName: event.companyName
      })),
      setStreetAddress: assign((context: any, event: any) => ({
        streetAddress: event.streetAddress
      })),
      setStreetAddress2: assign((context: any, event: any) => ({
        streetAddress2: event.streetAddress2
      })),
      setCity: assign((context: any, event: any) => ({
        city: event.city
      })),
      setState: assign((context: any, event: any) => ({
        state: event.state
      })),
      setPostalCode: assign((context: any, event: any) => ({
        postalCode: event.postalCode
      })),
      setCompanyPhoneNumber: assign((context: any, event: any) => ({
        companyPhoneNumber: event.companyPhoneNumber
      })),
      setTitle: assign((context: any, event: any) => ({
        title: event.title
      }))
    },
    guards: {
      isCompanyNameEmpty: (context: any, event: any) => {
        return isEmpty(context.companyName);
      },
      isStreetAddressEmpty: (context: any, event: any) => {
        return isEmpty(context.streetAddress);
      },
      isStreetAddress2Empty: (context: any, event: any) => {
        return isEmpty(context.streetAddress2);
      },
      isCityEmpty: (context: any, event: any) => {
        return isEmpty(context.city);
      },
      isStateEmpty: (context: any, event: any) => {
        return isEmpty(context.state);
      },
      isPostalCodeEmpty: (context: any, event: any) => {
        return isEmpty(context.postalCode);
      },
      isTitleEmpty: (context: any, event: any) => {
        return isEmpty(context.title);
      },

      isCompanyPhoneEmpty: (context: any, event: any) => {
        return isEmpty(context.companyPhoneNumber);
      },
      isCompanyPhoneFormatBad: (context: any, event: any) => {
        return validPhoneRegex.test(context.companyPhoneNumber);
      }
    }
  });

  return step2;
};
